import type {SpaceWDto} from '@cohort/wallet-schemas/space';
import {createContext} from 'react';

export type TransitionDirection = 'left' | 'right' | 'top' | 'bottom';

export interface Transitioning {
  active: boolean;
  enterFrom: TransitionDirection;
}

export interface SpaceW {
  space: SpaceWDto | undefined;
  transitioning: Transitioning;
  setTransitioning: (transitioning: Transitioning) => void;
  triggerRefresh: () => Promise<void>;
}

const SpaceContext = createContext<SpaceW | undefined>(undefined);

export default SpaceContext;
